import { Link } from "react-router-dom";
import Navbar from "@/components/Navbar";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen bg-[#F7F7F9]">
      <Navbar />
      <div className="max-w-2xl mx-auto px-6 py-20 text-center">
        <div className="border-2 border-[#0A0A0B] bg-white p-10">
          <XCircle className="w-12 h-12 mx-auto text-red-600" />
          <h1 className="display text-4xl mt-4">Paiement annulé</h1>
          <p className="text-zinc-600 mt-2">Vous pouvez réessayer depuis la mission.</p>
          <Link to="/dashboard">
            <button className="btn-anthracite mt-6" data-testid="cancel-back">Retour au dashboard</button>
          </Link>
        </div>
      </div>
    </div>
  );
}
